
import CircleLoading from '@/components/Loading/index.vue';
// import Nofile from '@/components/Nofile';
// import PullToRefresh from './components/pull-to-refresh/index.vue';
import GlobalEmpty from '@/components/GlobalEmpty.vue';
import Pagination from '@/components/Pagination';
import ModuleTitle from '@/components/ModuleTitle';
import AdvItem from '@/views/common/advItem';
import ModuleItem from '@/views/common/moduleItem';

const install = Vue => {
  Vue.component('CircleLoading', CircleLoading);
  Vue.component('GlobalEmpty', GlobalEmpty);
  Vue.component('Pagination', Pagination);
  Vue.component('ModuleTitle', ModuleTitle);
  Vue.component('AdvItem', AdvItem);
  Vue.component('ModuleItem', ModuleItem);
  // Vue.component('Nofile', Nofile);
  // Vue.component('pull-to-refresh', PullToRefresh);
};
export default install;
